import "./adminDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import AdminDetailsEditComponent from "./admin-details-edit/adminDetailsEditComponent";
import AdminDetailsViewComponent from "./admin-details-view/adminDetailsViewComponent";

interface AdminDetailsViewEditComponentProps {
    facilityDetails: any
    onUpdateAdminDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const AdminDetailsViewEditComponent = (props: AdminDetailsViewEditComponentProps) => {
    const {facilityDetails, onUpdateAdminDetails, onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [facilityAdminDetails, setFacilityAdminDetails] = useState<any>(undefined);
    //storing full facility details

    const handleAdminDetailsUpdate = useCallback((updatedAdminDetails: any) => {
        onUpdateAdminDetails(updatedAdminDetails);
        setMode("view");
    }, [onUpdateAdminDetails]);

    const handleAdminDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (facilityDetails) {
            setFacilityAdminDetails(facilityDetails);
        }
    }, [facilityDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange]);

    return (
        <div className={'admin-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <AdminDetailsViewComponent
                    facilityAdminDetails={facilityAdminDetails?.adminDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <AdminDetailsEditComponent
                                                              facilityDetails={facilityAdminDetails}
                                                              onUpdateComplete={handleAdminDetailsUpdate}
                                                              onEditCancel={handleAdminDetailsEditCancel}
                />
            }
        </div>
    );

};

export default AdminDetailsViewEditComponent;
